import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColStyled = styled(Col)`
 ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const thisIconDimension = rem(55);
    return css`
      padding: 0 ${rem(32)} ${rem(32)};
      text-align: ${mediumUp ? 'left' : 'center'};
      .understanding-product-grouping-primary-icon {
        width: ${thisIconDimension};
        height: ${thisIconDimension};
        margin-bottom: ${rem(16)};
      }
    `;
  }}
`;

export const RowStyledThreeItems = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      text-align: ${mediumUp ? 'left' : 'center'};
    `;
  }}
`;

export const RowStyledHeading = styled(Row)`
  ${({ hideHeading }) => {
    return css`
      ${hideHeading && 'display: none;'};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme, disableBottomPadding, cardDataArray, hideHeading }) => {
    const mediumUp = theme.mediumUp();
    let thisTopPadding = mediumUp ? rem(60) : rem(48); // default mobile, if not accordion
    let thisBottomPadding = rem(16); // default mobile, if not accordion

    if(disableBottomPadding){
      thisBottomPadding = 0;
    }else if(mediumUp){
      thisBottomPadding = rem(28);
    }else if(cardDataArray.length >= 4){
      thisBottomPadding = rem(32);
    }

    if(hideHeading && cardDataArray.length >= 4){
      thisTopPadding = mediumUp ? rem(48) : rem(10);
    }

    return css`
      && {
        padding-top: ${thisTopPadding};
        padding-bottom: ${thisBottomPadding};
      }
    `;
  }}
`;

export const TypographyStyledHeading = styled(Typography)`
  ${({ theme, cardDataArray, hasHeadingSubtext }) => {
    const mediumUp = theme.mediumUp();
    let thisPaddingBottom = mediumUp ? rem(16) : rem(12); // if subtext is present

    if(!hasHeadingSubtext){ // if no subtext
      if(cardDataArray.length >= 4){
        thisPaddingBottom = mediumUp ? rem(40) : 0;  // when there is no section subtext and there is a mobile accordion
      }else{
        thisPaddingBottom = mediumUp ? rem(40) : rem(24);  // when there is no section subtext and there is no mobile accordion
      }
    }

    return css`
      padding-bottom: ${thisPaddingBottom};
    `;
  }}
`;

export const TypographyStyledHeadingSubText = styled(Typography)`
  ${({ theme, cardDataArray }) => {
    const mediumUp = theme.mediumUp();

    let thisPaddingBottom = mediumUp ? rem(40) : rem(24); // if no mobile accordion

    if(cardDataArray.length >= 4){
      thisPaddingBottom = mediumUp ? rem(40) : 0;  // when there is a mobile accordion
    }

    return css`
      padding-bottom: ${thisPaddingBottom};
    `;
  }}
`;